import { render, staticRenderFns } from "./AnalyticsBestSellers.vue?vue&type=template&id=2e9e1957"
import script from "./AnalyticsBestSellers.vue?vue&type=script&lang=js"
export * from "./AnalyticsBestSellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports